import { combineReducers } from 'redux';

import { configureStore } from '@reduxjs/toolkit';

import app from './app/slice';
import modal from './modal/slice';
import user from './user/slice';
import documents from './documents/slice';
import normalizer from './normalizer/slice';
import configurator from './configurator/slice';
import userReportSettings from './userReportSettings/slice';
import chatbot from './chatbot/slice';

const reducer = combineReducers({
  user,
  documents,
  normalizer,
  modal,
  app,
  configurator,
  userReportSettings,
  chatbot,
});

export const createStore = () =>
  configureStore({
    reducer,
    // Ignore non-serializable data
    // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: ['modal/setModal'],
        },
      }),
    devTools: process.env.NODE_ENV === 'development',
  });
const store = createStore();
export default store;
